import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faListCheck } from '@fortawesome/pro-light-svg-icons';

export type ProLightListCheckProps = IconComponentProps;

export const ProLightListCheck = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightListCheckProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faListCheck}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faListCheck}
    />
  );
};

ProLightListCheck.displayName = 'ProLightListCheck';
